module.exports = __webpack_public_path__ + "img/38.9b71025c.jpg";